export class Trie<T> {
  private _root: TrieNode<T>;

  constructor() {
    this._root = new TrieNode<T>();
  }

  // Splits the name and adds the obj to the tree for each resulting "word"
  put(name: string, obj: T) {
    const keys: string[] = this.getWords(name);
    // Also add the original search without splitting it, if not already in the list
    // This would allow i.e. "+name" being filtered with and without the '+'
    this.addToList(keys, [name]);
    for (let key of keys) {
      let node = this._root;
      key = key.toLowerCase();
      for (let i = 0; i < key.length; i++) {
        const c = key.charAt(i);
        node = node.getOrInsertChild(c);
        node.addValue(obj);
      }
    }
  }

  // Splits the search string and finds all results that match all words
  get(search: string): T[] {
    const words = this.getWords(search.toLowerCase());
    if (words.length == 0) {
      return [];
    }
    // Get all matches for the first word
    let results = this.getSingle(words[0]);
    for (let i = 1; i < words.length; i++) {
      results = this.intersection(results, this.getSingle(words[i]));
    }
    // Also merge with results from the unmodified search
    if (!this.contains(words, search)) {
      this.addToList(results, this.getSingle(search));
    }
    return results;
  }

  private intersection(list: T[], other: T[]) {
    const result = [];
    for (let i = 0; i < list.length; i++) {
      if (other.indexOf(list[i]) >= 0) {
        result.push(list[i]);
      }
    }
    return result;
  }

  // All all items to the list, except duplicates
  private addToList(list: any[], items: any[]) {
    for (let i = 0; i < items.length; i++) {
      if (!this.contains(list, items[i])) {
        list.push(items[i]);
      }
    }
  }

  private contains(list: any[], item: any) {
    for (let i = 0; i < list.length; i++) {
      if (list[i] == item) {
        return true;
      }
    }
    return false;
  }

  clear() {
    this._root = new TrieNode<T>();
  }

  private getWords(str: string) {
    return str.trim().split(/[^a-zA-Z0-9]/);
  }

  private getSingle(search: string): T[] {
    let node = this._root;
    let i, c, child;
    for (i = 0; i < search.length; i++) {
      c = search.charAt(i);
      child = node.getChild(c);
      if (!child) {
        return [];
      }
      node = child;
    }
    return node.getValues();
  }
}

class TrieNode<T> {
  private _children: { [key: string]: TrieNode<T> };
  private _values: T[];

  constructor() {
    this._values = [];
    this._children = {};
  }

  getChild(key: string): TrieNode<T> {
    return this._children[key];
  }

  addValue(obj: T) {
    for (const i in this._values) {
      if (obj == this._values[i]) {
        return; // already added.
      }
    }
    this._values.push(obj);
  }

  getValues(): T[] {
    return this._values;
  }

  insertChild(key: string, node: TrieNode<T>) {
    this._children[key] = node;
  }

  getOrInsertChild(key: string): TrieNode<T> {
    const child = this._children[key];
    if (child) {
      return child;
    } else {
      const insert = new TrieNode<T>();
      // this.insertC hild(c, insert);
      this._children[key] = insert;
      return insert;
    }
  }
}
